
  import '@strudel/repl';
  import {
    fullInitialize,
    getAudioContext
  } from '/assets/js/dsonic-strudel.js';
  import { initSidebarObserver } from '/assets/js/sidebar-observer.js';

  let activeEditor = null;

  // Initialize DSonic with engine sounds only (no templates needed on engines page)
  (async () => {
    await fullInitialize({ registerTemplates: false, registerEngines: true });
  })();

  function addControlBars() {
    document.querySelectorAll('.code-block').forEach((block) => {
      const editor = block.querySelector('strudel-editor');
      if (!editor || block.querySelector('.editor-controls')) return;

      const controls = document.createElement('div');
      controls.className = 'editor-controls';
      controls.innerHTML = `
        <button class="control-btn play-btn">&#9654; Play</button>
        <button class="control-btn stop-btn">&#9632; Stop</button>
        <button class="control-btn update-btn">&#8635; Update</button>
        <span class="control-hint">Ctrl+Enter | Ctrl+. | Ctrl+U</span>
      `;
      block.insertBefore(controls, block.firstChild);

      const playBtn = controls.querySelector('.play-btn');
      const stopBtn = controls.querySelector('.stop-btn');
      const updateBtn = controls.querySelector('.update-btn');

      playBtn.addEventListener('click', async () => {
        const ctx = getAudioContext();
        if (ctx.state === 'suspended') await ctx.resume();

        // Stop previous editor if different
        if (activeEditor && activeEditor !== editor && activeEditor.editor?.stop) {
          activeEditor.editor.stop();
          activeEditor.closest('.code-block')?.querySelector('.play-btn')?.classList.remove('playing');
          activeEditor = null;
          // Wait for Strudel to fully process the stop before starting new pattern
          await new Promise(r => setTimeout(r, 100));
        }

        // Start new editor
        if (editor.editor?.toggle) {
          await editor.editor.toggle();
          playBtn.classList.add('playing');
          activeEditor = editor;
        }
      });

      stopBtn.addEventListener('click', () => {
        if (editor.editor?.stop) {
          editor.editor.stop();
          playBtn.classList.remove('playing');
        }
      });

      updateBtn.addEventListener('click', async () => {
        const ctx = getAudioContext();
        if (ctx.state === 'suspended') await ctx.resume();
        if (editor.editor?.evaluate) {
          await editor.editor.evaluate();
          playBtn.classList.add('playing');
          activeEditor = editor;
        } else if (editor.editor?.toggle) {
          await editor.editor.toggle();
          playBtn.classList.add('playing');
          activeEditor = editor;
        }
      });
    });
  }

  document.addEventListener('keydown', async (e) => {
    if (e.ctrlKey && e.key === 'Enter') {
      const ctx = getAudioContext();
      if (ctx.state === 'suspended') await ctx.resume();
      const focusedEditor = document.activeElement?.closest('.code-block')?.querySelector('strudel-editor');
      if (focusedEditor && activeEditor && activeEditor !== focusedEditor && activeEditor.editor?.stop) {
        activeEditor.editor.stop();
        activeEditor.closest('.code-block')?.querySelector('.play-btn')?.classList.remove('playing');
      }
      if (focusedEditor) {
        setTimeout(() => {
          activeEditor = focusedEditor;
          focusedEditor.closest('.code-block')?.querySelector('.play-btn')?.classList.add('playing');
        }, 50);
      }
    }
    if (e.ctrlKey && e.key === 'u' && activeEditor) {
      e.preventDefault();
      const ctx = getAudioContext();
      if (ctx.state === 'suspended') await ctx.resume();
      if (activeEditor.editor?.evaluate) await activeEditor.editor.evaluate();
      else if (activeEditor.editor?.toggle) await activeEditor.editor.toggle();
    }
  }, { capture: true });

  setTimeout(addControlBars, 500);

  // Initialize sidebar observer for engine sections
  initSidebarObserver({
    sectionSelector: '.engine-section',
    linkSelector: '.sidebar-nav a'
  });
